import { render, staticRenderFns } from "./Unit.vue?vue&type=template&id=2cf85c66"
import script from "./Unit.vue?vue&type=script&lang=ts"
export * from "./Unit.vue?vue&type=script&lang=ts"
import style0 from "./Unit.vue?vue&type=style&index=0&id=2cf85c66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports